import { useCallback } from 'react'
import { createApiRequest } from 'src/store/api'

export const getGoogleAutocompleteOptions = ({ text, params = {} }) => {
  return createApiRequest({
    method: 'get',
    url: `/google-maps/autocomplete/predict?input=${text}`,
    params,
  })
}
export const useMapAutocomplete = () => {
  const getPlacesQuery = useCallback(async (text: string) => {
    const { data } = await getGoogleAutocompleteOptions({
      text: text,
    })

    return data.predictions.map((predict) => ({
      ...predict,
      address: predict.label,
      placeId: predict.value,
    }))
  }, [])

  const getDescriptionAndLocation = useCallback(
    async (text) => {
      const result = await getPlacesQuery(text)
      return result
    },
    [getPlacesQuery]
  )

  return { getPlacesQuery, getDescriptionAndLocation }
}
